module.exports = __webpack_public_path__ + "img/international-consulting-light.64e3d81e.png";